import { Link } from "react-router-dom";

export default function HomeCTA() {
  return (
    <section className="py-14 md:py-20 bg-accent-500 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,oklch(0.85_0.15_170/0.3),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,oklch(0.9_0.08_85/0.2),transparent_50%)]"></div>
      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 dark:text-foreground-950 mb-4">
          立即开始使用JM网页版
        </h2>
        <p className="text-background-50/80 dark:text-foreground-950/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
          收藏本页面，随时获取JM网页版最新官方入口地址。无需下载，打开浏览器即可使用。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#jm-entry"
            className="px-8 py-3 bg-background-50 text-accent-600 rounded-lg text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            直达JM官网入口
          </a>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/40 text-background-50 dark:text-foreground-950 rounded-lg text-sm font-semibold hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}